import SearchResultPaginationShowMore from './SearchResultPaginationShowMore';

export default SearchResultPaginationShowMore;
